const injectedFamilySets = new Set<string>();

export const extractFamilyName = (cssFontFamily: string): string =>
    cssFontFamily.split(',')[0].trim().replace(/^['"]|['"]$/g, '');

// Given full CSS font-family values (e.g. "Playfair Display, serif"), ensures a Google
// Fonts stylesheet covering the bare family names is present in <head>. Idempotent per
// unique set of families — Google's css2 endpoint silently ignores names it doesn't
// recognize (e.g. "sans-serif", "Arial"), so the raw option list can be passed through
// without filtering.
export const ensureGoogleFontsLoaded = (cssFontFamilyValues: string[]): void => {
    const families = Array.from(new Set(cssFontFamilyValues.map(extractFamilyName))).filter(Boolean);
    if (!families.length) return;

    const key = families.slice().sort().join('|');
    if (injectedFamilySets.has(key)) return;
    injectedFamilySets.add(key);

    const href = `https://fonts.googleapis.com/css2?${families
        .map((name) => `family=${encodeURIComponent(name)}`)
        .join('&')}&display=swap`;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
};
